"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var observable_1 = require("../player/observable");
var Input = (function () {
    function Input(window) {
        var _this = this;
        this.keyCodeMap = {};
        this.preventDefault = new Set([-1]);
        this.keyUpObservable = new observable_1.Observable();
        this.keyDownObservable = new observable_1.Observable();
        window.onkeydown = function (event) {
            _this.handleKeyDown(event);
        };
        window.onkeyup = function (event) {
            _this.handleKeyUp(event);
        };
    }
    Input.prototype.onKeyUp = function (handler) {
        this.keyUpObservable.registerObserver(handler, this);
    };
    Input.prototype.onKeyDown = function (handler) {
        this.keyDownObservable.registerObserver(handler, this);
    };
    Input.prototype.removeKeyUpListener = function (handler) {
        this.keyUpObservable.unregisterObserver(handler);
    };
    Input.prototype.removeKeyDownListener = function (handler) {
        this.keyDownObservable.unregisterObserver(handler);
    };
    Input.prototype.removeAllKeyUpListeners = function () {
        this.keyUpObservable.unregisterObservers(this);
    };
    Input.prototype.removeAllKeyDownListeners = function () {
        this.keyDownObservable.unregisterObservers(this);
    };
    Input.prototype.removeAllListeners = function () {
        this.keyUpObservable.unregisterObservers(this);
        this.keyDownObservable.unregisterObservers(this);
    };
    Input.prototype.handleKeyDown = function (event) {
        this.handleKeyEvent(this.keyDownObservable, event);
    };
    Input.prototype.handleKeyUp = function (event) {
        this.handleKeyEvent(this.keyUpObservable, event);
    };
    Input.prototype.handleKeyEvent = function (keyEventObservable, event) {
        if (this.preventDefault.has(event.keyCode)) {
            if (event.preventDefault) {
                event.preventDefault();
            }
        }
        var ctvKeys = client_lib_js_player_framework_utils_1.lookupCTVKeysForKeyCode(this.keyCodeMap, event.keyCode);
        var key = ctvKeys[0], secondaryKey = ctvKeys[1], otherKeys = ctvKeys.slice(2);
        var extendedEvent = {
            key: key,
            keyCode: event.keyCode,
        };
        if (ctvKeys.length > 1) {
            extendedEvent.secondaryKey = secondaryKey;
            extendedEvent.otherKeys = [secondaryKey].concat(otherKeys);
        }
        keyEventObservable.notifyObservers(extendedEvent);
    };
    return Input;
}());
exports.Input = Input;
